package at.theatervogelweide.admin.contract.people

import at.theatervogelweide.admin.contract.AdminResult
import at.theatervogelweide.admin.contract.VersionedId
import kotlinx.rpc.annotations.Rpc

/**
 * Personen (#23), sorted by first and last name like the public server's person API.
 *
 * The photo is uploaded over plain HTTP to `POST /api/images/persons` first; the [PersonDraft] then names it, and
 * saving it replaces the old photo, whose file is deleted.
 */
@Rpc
interface PeopleService {
    suspend fun list(): AdminResult<List<PersonListEntry>>

    suspend fun load(id: Long): AdminResult<PersonEditor>

    suspend fun create(draft: PersonDraft): AdminResult<PersonEditor>

    /** Removing the address deletes it. */
    suspend fun save(person: VersionedId, draft: PersonDraft): AdminResult<PersonEditor>

    /**
     * Deletes the person with their address, photo and board memberships. Refused while a role, a sign-in account or
     * a mail refers to them (see [PersonEditor.deleteBlocker]), as the public server refuses it. [addressVersion] is
     * [PersonDraft.addressVersion] as loaded: an address changed elsewhere meanwhile is a conflict, as on saving.
     */
    suspend fun delete(person: VersionedId, addressVersion: Long?): AdminResult<Unit>
}
